import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AdminPermission, AdminPermissionPreset, AdminPermissionPresetPayload } from 'mbs-ui-shared@models/AdminPermissionPreset';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminPermissionPresetsService {
  private http = inject(HttpClient);

  private readonly baseHref = '/api/admin-permission-presets';
  private readonly permissionsHref = '/api/admin-permissions';

  public get(): Observable<AdminPermissionPreset[]> {
    return this.http.get<AdminPermissionPreset[]>(this.baseHref);
  }

  public create(preset: AdminPermissionPresetPayload): Observable<AdminPermissionPreset> {
    return this.http.post<AdminPermissionPreset>(this.baseHref, preset);
  }

  public update(presetId: string, preset: AdminPermissionPresetPayload): Observable<AdminPermissionPreset> {
    return this.http.put<AdminPermissionPreset>(`${this.baseHref}/${presetId}`, preset);
  }

  public delete(presetId: string): Observable<null> {
    return this.http.delete<null>(`${this.baseHref}/${presetId}`);
  }

  public getAvailablePermissions(): Observable<AdminPermission[]> {
    return this.http.get<AdminPermission[]>(this.permissionsHref);
  }
}
